import { FONTS, COLORS } from '../../../../constants';

const styles = () => ({
  ordersInfoWrapper: {
    backgroundColor: COLORS.WHITE_DARK,
    padding: '20px 0',
  },
  jobItem: {
    marginBottom: 10,
  },
  heading: {
    fontFamily: FONTS.PRIMARY,
    fontWeight: 600,
    fontSize: '1.125rem',
    padding: '0 15px 20px 15px',
    margin: 0,
  },
  sortButton: {
    width: '100%',
  },
  arrowDownIcon: {
    color: COLORS.GREY_DARK,
    position: 'absolute',
    right: 5,
  },
  sortButtonWrapper: {
    padding: '0 15px 20px 15px',
  },
  createJobContainer: {
    position: 'fixed',
    display: 'grid',
    gridTemplateColumns: '20% 80%',
    bottom: 0,
    left: 0,
    width: '100%',
    borderRadius: 0,
  },
  createJobTooltip: {
    backgroundColor: COLORS.GREY,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  createJobButton: {
    borderRadius: 0,
    textTransform: 'capitalize',
  },
});
export default styles;
